<div *commonUiOptionalWizardStep>
  <div class="mb-5x">
    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.TITEL' | translate }}</h2>
    <div class="d-none d-sm-flex mb-3x form-row justify-content-between">
      <p class="col-sm-5 festsetzung-col-label">
        {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.UEBERSCHRIFT_GRUENDUNGSJAHR' | translate }}
      </p>
      <p class="col-sm-5 festsetzung-col-label">
        {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.UEBERSCHRIFT_FOLGEJAHR' | translate }}
      </p>
    </div>
    <common-ui-festsetzung-vorauszahlungen [(data)]="data" [readonly]="readonly">
    </common-ui-festsetzung-vorauszahlungen>
  </div>
</div>
